// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
// import '../assets/css/style.css';
// import logo from '../assets/images/logo.png';

function Footer() {
  return (
    <footer className="footer-container-wrapper">
      <div className="container">
        <div className="row">
          {/* Footer Logo */}
          <div className="col-12 col-md-4 footer-logo">
            <a href="/">
              <img className="footerLogo" src="/assets/images/footer-logo.png" alt="B2B" width="210" />
            </a>
            <p>CIN:U67200DL2002PLC117625</p>
            <p>
              Bajaj Capital Insurance Broking Limited<br />
              Bajaj House, 97, Nehru Place, New Delhi -110019
            </p>
            <p>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = 'mailto:care@bajajcapital.com';
                }}
              >
                care[at]bajajcapital[dot]com
              </a>
            </p>
            <p>
              <a href="tel:1800-212-123123">1800 212 123123</a>
            </p>
          </div>

          {/* Services */}
          <div className="col-12 col-md footer-nav">
            <h4>Our Services</h4>
            <ul>
              <li>
                <a href="https://dev.bajajcapitalinsurance.com/general-insurance/pet/input/customer-details" target="_blank" rel="noopener noreferrer">
                  Pet Insurance
                </a>
              </li>
              <li>
                <a href="https://www.bajajcapitalinsurance.com/general-insurance/bike/lead-page" target="_blank" rel="noopener noreferrer">
                  2 Wheeler Insurance
                </a>
              </li>
              <li>
                <a href="https://www.bajajcapitalinsurance.com/general-insurance/car/lead-page" target="_blank" rel="noopener noreferrer">
                  Car Insurance
                </a>
              </li>
              <li>
                <a href="https://www.bajajcapitalinsurance.com/general-insurance/health/input/basic-details" target="_blank" rel="noopener noreferrer">
                  Health Insurance
                </a>
              </li>
              <li>
                <a href="https://marketing.bajajcapitalinsurance.com/get-term-quote" target="_blank" rel="noopener noreferrer">
                  Term Life Insurance
                </a>
              </li>
              <li>
                <a href="https://renew-all.bajajcapitalinsurance.com/" target="_blank" rel="noopener noreferrer">
                  All Renewals
                </a>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="col-12 col-md footer-nav">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><a href="https://pos.bajajcapitalinsurance.com/" target="_blank" rel="noopener noreferrer">Earn with Us</a></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li>
                <span>Annual Return</span>
                <ul className="annual-return-submenu">
                  <li><a href="/assets/docs/2018.pdf" target="_blank" rel="noopener noreferrer"> 2018 </a>|
                    <a href="/assets/docs/2019.pdf" target="_blank" rel="noopener noreferrer"> 2019 </a>|
                    <a href="/assets/docs/2020.pdf" target="_blank" rel="noopener noreferrer"> 2020 </a>|
                    <a href="/assets/docs/2021.pdf" target="_blank" rel="noopener noreferrer"> 2021 </a>|
                    <a href="/assets/docs/2022.pdf" target="_blank" rel="noopener noreferrer"> 2022 </a></li>
                </ul>
              </li>
            </ul>
          </div>

          {/* Legal & Compliance */}
          <div className="col-12 col-md footer-nav">
            <h4>Legal &amp; Compliance</h4>
            <ul>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/term-and-condition">Terms & Conditions</Link></li>
              <li><Link to="/disclaimer">Disclaimer</Link></li>
              <li><Link to="/csr-policy">CSR Policy</Link></li>
              <li><Link to="/BCIBL-Anti-Fraud-Policy">Anti-Fraud Policy</Link></li>
            </ul>
          </div>

          {/* Social */}
          <div className="col-12 col-md social">
            <h4>Follow Us</h4>
            <ul className="social-links">
              <li>
                <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/bajajcapitalinsurance">
                  <img src="/assets/icons/facebook-icon.png" alt="facebook" />
                </a>
              </li>
              <li>
                <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/bcl_insurance">
                  <img src="/assets/icons/twitter-icon.png" alt="twitter" />
                </a>
              </li>
              <li>
                <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/bajaj.capital.insurance/">
                  <img src="/assets/icons/instagram-icon.png" alt="instagram" />
                </a>
              </li>
              <li>
                <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/bajaj-capital-insurance-broking-ltd/">
                  <img src="/assets/icons/linkden-icon.png" alt="LinkedIn" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Text */}
      <div className="container">
        <hr />
        <p className="description">
          This site is owned and operated by Bajaj Capital Insurance Broking Limited [“BCIBL” (CIN:U67200DL2002PLC117625)],
          an IRDA licensed Composite Broker bearing{' '}
          <a style={{ color: '#2c91fe' }} href="/assets/docs/BrokingCertificate.pdf" target="_blank" rel="noopener noreferrer">
            License No. 241, License Code CB 042/02
          </a>, license dated 09-01-2025 valid till 08-01-2028 (originally licensed by IRDA on 09/01/2004 and renewed thereafter). BCIBL is a member of Insurance Brokers Association of India (Membership No.119). The Prospect’s/visitor’s particulars could be shared with insurers. The information displayed on this website is of the insurers with whom BCIBL has an agreement. Insurance is the subject matter of solicitation.
        </p>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom-pane">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <p className="copyright text-center">
                Copyright © 2022 Bajaj Capital Insurance Broking Limited
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>


  );
}

export default Footer;
